import { FormlyFieldConfig } from "@ngx-formly/core";

export function documentInvoiceReceiverAddressFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            className: "!px-0",
            fieldGroupClassName: "flex flex-wrap !px-0",
            wrappers: [],
            fieldGroup: [
                {
                    key: "titleIdentifier",
                    className: "w-full",
                    type: "formly-salutation-drop-down",
                    expressions: {
                        hide: "formState.detailComponent.detailModel?.invoiceReceiverAddress?.isPrivatePerson === false"
                    },
                    props: {
                        label: "crm.title",
                        translate: true,
                        autoLoad: false,
                        attributes: {
                            optionValue: 'identifier',
                            'data-testid': 'invoice-receiver-address-title'
                        }
                    }
                },
                {
                    key: "recipient",
                    className: "w-full",
                    type: "input",
                    props: {
                        label: "postal-address.recipient",
                        translate: true,
                        trimLeading: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-recipient'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "addition",
                    className: "w-full",
                    type: "input",
                    props: {
                        label: "postal-address.addition",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-addition'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "addition2",
                    className: "w-full",
                    type: "input",
                    props: {
                        label: "postal-address.addition2",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-addition2'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "addition3",
                    className: "w-full",
                    type: "input",
                    props: {
                        label: "postal-address.addition3",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-addition3'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "street",
                    className: "w-full md:w-4/5",
                    type: "input",
                    props: {
                        label: "postal-address.street",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-street'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "streetNumber",
                    className: "w-full md:w-1/5",
                    type: "input",
                    props: {
                        label: "postal-address.streetNumber",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-streetNumber'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "countryIso",
                    className: "w-full md:w-1/2",
                    type: "formly-country-input",
                    props: {
                        isoMode: true,
                        label: "postal-address.country",
                        translate: true,
                        autoLoad: false,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-country'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "state",
                    className: "w-full md:w-1/2",
                    type: "input",
                    props: {
                        label: "postal-address.state",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-state'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "postalCode",
                    className: "w-full md:w-1/2",
                    type: "formly-zipcode-auto-complete",
                    props: {
                        label: "postal-address.postalCode",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-postalCode'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "city",
                    className: "w-full md:w-1/2",
                    type: "input",
                    props: {
                        label: "postal-address.city",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-city'
                        }
                    },
                    wrappers: [
                        "simple-title"
                    ]
                },
                {
                    key: "phone",
                    className: "w-full md:w-1/2",
                    type: "formly-phone-input",
                    props: {
                        label: "postal-address.phone",
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-phone'
                        }
                    },
                    expressions: {
                        'props.countryIso': 'model.countryIso'
                    },
                    modelOptions: {
                        updateOn: 'blur',
                        debounce: {
                            default: 500
                        }
                    }
                },
                {
                    key: "email",
                    className: "w-full md:w-1/2",
                    type: "formly-mail-input",
                    props: {
                        label: "postal-address.email",
                        translate: true,
                        type: 'email',
                        icon: 'fa fa-envelope',
                        attributes: {
                            'data-testid': 'invoice-receiver-address-email'
                        }
                    },
                    validators: {
                        validation: ['mails']
                    },
                    modelOptions: {
                        updateOn: 'change',
                    }
                },
                {
                    key: 'vatId',
                    className: "w-full md:w-1/2",
                    type: 'formly-vat-id-input',
                    props: {
                        label: 'postal-address.vat-id',
                        translate: true,
                        vatCheckTarget: 'postalAddress',
                        attributes: {
                            'data-testid': 'invoice-receiver-address-vatId'
                        }
                    },
                },
                {
                    key: 'taxId',
                    className: "w-full md:w-1/2",
                    type: 'input',
                    props: {
                        label: 'postal-address.tax-id',
                        translate: true,
                        attributes: {
                            'data-testid': 'invoice-receiver-address-taxId'
                        }
                    },
                }
            ]
        }]
}


// function getPostalFields(keyPrefix: string, i18n: I18nService): FormlyFieldConfig[] {
//     let config =
//         [
//
//     return config;
// };


